import type { CycleEvaluationGroupStepsType } from '@/constants/cycle-evaluation/CycleEvaluationGroupSteps';
import type { ComponentType } from 'react';

import { CycleEvaluationGroupSteps } from '@/constants/cycle-evaluation/CycleEvaluationGroupSteps';
import { CommunicationsPage } from '@/pages/CycleEvaluation/Communications/CommunicationsPage';
import { CycleInformationPage } from '@/pages/CycleEvaluation/CycleInformation/CycleInformationPage';
import { DeadlinesPage } from '@/pages/CycleEvaluation/Deadlines/DeadlinesPage';
import { EvaluationElementsPage } from '@/pages/CycleEvaluation/EvaluationElements/EvaluationElementsPage';
import { SelectEvaluatorsPage } from '@/pages/CycleEvaluation/SelectEvaluators/SelectEvaluatorsPage';

/**
 * Page mounted at each step of the configuration flow.
 *
 * The extension point of this navigator: each step page is owned by its own card, which registers
 * its own entry here. A step with no entry routes normally and renders an empty content area —
 * nothing invented stands in for a page that does not exist yet.
 */
export const CYCLE_EVALUATION_GROUP_STEP_COMPONENTS: Partial<
    Record<CycleEvaluationGroupStepsType, ComponentType>
> = {
    [CycleEvaluationGroupSteps.CYCLE_INFORMATION]: CycleInformationPage,
    [CycleEvaluationGroupSteps.EVALUATION_ELEMENTS]: EvaluationElementsPage,
    [CycleEvaluationGroupSteps.FEEDBACK_360_SETTINGS]: SelectEvaluatorsPage,
    [CycleEvaluationGroupSteps.DEADLINES]: DeadlinesPage,
    [CycleEvaluationGroupSteps.COMMUNICATIONS]: CommunicationsPage,
};
